import { FormFields } from '@epi-forms/helpers';

export const getPayroll = (name: string) => `${FormFields.Payroll}.${name}`;
export const getIncomesRegister = (name: string) =>
  `${FormFields.IncomeRegister}.${name}`;
